import { PhotoAndTextCardFieldsFragment } from '../../../@types/generated';
import { getOr } from '@/utils/options';
import ListItem, { List } from 'components/src/list';
import Image from 'next/image';

type Props = {
  data: PhotoAndTextCardFieldsFragment;
};

const ListItemSection = ({ data }: Props) => {
  return (
    data.listItems?.itemCollection?.items && (
      <List>
        {data.listItems.itemCollection.items.map((item, index) => (
          <ListItem
            key={index}
            id={getOr(item?.title, index.toString())}
            text={getOr(item?.title, '')}
            icon={<Image src={getOr(item?.icon?.url, '')} fill alt={getOr(item?.title, 'icon')} />}
          ></ListItem>
        ))}
      </List>
    )
  );
};
export default ListItemSection;
